import { useState, useEffect } from "react";

/**
 * Ensures a loading state stays visible for at least `minMs` milliseconds.
 * Prevents invisible flash-of-spinner on fast local/LAN connections.
 * Remove or set minMs=0 before go-live if you prefer instant transitions.
 */
export default function useMinLoad(loading, minMs = 500) {
  const [show, setShow] = useState(loading);

  useEffect(() => {
    if (loading) {
      setShow(true);
    } else {
      const t = setTimeout(() => setShow(false), minMs);
      return () => clearTimeout(t);
    }
  }, [loading, minMs]);

  return show;
}
